import Phaser from 'phaser';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    console.log('BootScene preload started');
    
    // Fill the entire screen with the background color first
    const bg = this.add.graphics();
    bg.fillStyle(0x20609a, 1);
    bg.fillRect(0, 0, window.innerWidth, window.innerHeight);
    
    // Create loading bar
    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    const barWidth = Math.min(width * 0.5, 300);
    const barHeight = 50;
    const barX = (width - barWidth) / 2;
    const barY = height / 2 - 30;
    
    progressBox.fillRect(barX, barY, barWidth, barHeight);
    
    const loadingText = this.add.text(width / 2, barY - 20, 'Loading...', {
      font: '20px Arial',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 2
    }).setOrigin(0.5, 0.5);
    
    const percentText = this.add.text(width / 2, barY + barHeight / 2, '0%', {
      font: '18px Arial',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 1
    }).setOrigin(0.5, 0.5);
    
    // Update the loading bar as assets are loaded
    this.load.on('progress', (value: number) => {
      console.log(`BootScene loading progress: ${Math.floor(value * 100)}%`);
      percentText.setText(parseInt(String(value * 100)) + '%');
      progressBar.clear();
      progressBar.fillStyle(0x9ad9ea, 1);
      progressBar.fillRect(barX + 10, barY + 10, (barWidth - 20) * value, barHeight - 20);
    });
    
    // Log errors during loading
    this.load.on('loaderror', (file: any) => {
      console.error(`Error loading file in BootScene: ${file.key} (${file.url})`);
    });
    
    this.load.on('complete', () => {
      console.log('BootScene asset loading complete');
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
      percentText.destroy();
    });
  }

  create(): void {
    // Add a simple underwater background color gradient
    const gradient = this.add.graphics();
    const gradientColors = [0x20609a, 0x0d2b3e]; // Lighter blue to darker blue
    
    // Fill the entire screen with the background color first
    gradient.fillStyle(0x1a4e6e, 1);
    gradient.fillRect(0, 0, window.innerWidth, window.innerHeight);
    
    const height = this.cameras.main.height;
    
    for (let y = 0; y < height; y++) {
      const color = Phaser.Display.Color.Interpolate.ColorWithColor(
        Phaser.Display.Color.ValueToColor(gradientColors[0]),
        Phaser.Display.Color.ValueToColor(gradientColors[1]),
        height,
        Math.floor(y)
      );
      
      gradient.fillStyle(Phaser.Display.Color.GetColor(color.r, color.g, color.b), 1);
      gradient.fillRect(0, y, this.cameras.main.width, 1);
    }
    
    // Transition to the start scene instead of the game scene
    this.cameras.main.fadeOut(500);
    this.time.delayedCall(500, () => {
      this.scene.start('StartScene');
    });
  }
} 